// ---------------- Hook to call the api endpoint for the tickers -------------------
// ----------------------------------------------------------------------------------
import { useState, useEffect } from 'react';
import { getAvailableTickers } from '../services/api';


export const useAvailableTickers = () => {

  // create state variables for tickers, loading, and error
  const [tickers, setTickers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // effect to call the API to get available tickers when the component mounts
  useEffect(() => {
    let cancelled = false;
    
    getAvailableTickers() // call the API to get available tickers
      .then((response) => { if (!cancelled) setTickers(response.tickers || []); }) // set the tickers state variable with the response
      .catch((err) => { 
        if (cancelled) return; // if there is an error, print it and set the error state
        console.error('Error fetching tickers:', err);
        setError(err.message || 'Failed to load tickers'); // either the actual message or a filler
        setTickers([]); // set the tickers to empty if there is an error
      })
      .finally(() => { if (!cancelled) setLoading(false); }); // set the loading to false when the request is complete
    
    return () => { cancelled = true; }; // prevent state updates if the component is unmounted while running
  }, []);

  return { tickers, loading, error }; // return the tickers and state variables
};
